const breadcrumbsHome = { name: 'Home', pathName: '/home' }
const breadcrumbsConfiguracoes = { name: 'Configurações' }
export default [
  {
    path: '/configuracoes/units',
    component: () => import('@/modules/configuracoes/lojas/views/pages/Lojas.vue'),
    meta: {
      title: 'Lojas',
      breadcrumbs: [
        breadcrumbsHome,
        breadcrumbsConfiguracoes,
        {
          name: 'Lojas',
          pathName: null,
        },
      ],
      pagePermission: 'configuracoes/lojas',
    },
  },
  {
    path: '/configuracoes/gerais',
    component: () => import('@/modules/configuracoes/gerais/views/pages/GeneralSettings.vue'),
    meta: {
      title: 'Gerais',
      breadcrumbs: [
        breadcrumbsHome,
        breadcrumbsConfiguracoes,
        {
          name: 'Gerais',
          pathName: null,
        },
      ],
      pagePermission: 'usuarios/permissionamento',
    },
  },
  {
    path: '/configuracoes/redes-sociais',
    component: () => import('@/modules/configuracoes/redes-sociais/views/pages/RedesSociais.vue'),
    meta: {
      title: 'Redes sociais',
      breadcrumbs: [
        breadcrumbsHome,
        breadcrumbsConfiguracoes,
        {
          name: 'Redes sociais',
          pathName: null,
        },
      ],
      pagePermission: 'configuracoes/redes-sociais',
    },
  },
  {
    path: '/configuracoes/site-cadastramento',
    component: () => import('@/modules/configuracoes/site-de-cadastramento/views/pages/Hotsite.vue'),
    name: 'site-cadastramento',
    meta: {
      title: 'Site de cadastramento',
      breadcrumbs: [
        breadcrumbsHome,
        breadcrumbsConfiguracoes,
        {
          name: 'Site de cadastramento',
          pathName: null,
        },
      ],
      pagePermission: 'configuracoes/site-cadastramento',
    },
  },
  {
    path: '/configuracoes/site-cadastramento/hotsite-slot/:id',
    component: () => import('@/modules/configuracoes/site-de-cadastramento/views/pages/HotsiteSlot.vue'),
    name: 'edit-hotsite-slot',
    meta: {
      title: 'Configuração do hotsite',
      breadcrumbs: [
        breadcrumbsHome,
        breadcrumbsConfiguracoes,
        {
          name: 'Site de cadastramento',
          pathName: '/configuracoes/site-cadastramento',
        },
        {
          name: 'Configuração do hotsite',
          pathName: null,
        },
      ],
      pagePermission: 'configuracoes/site-cadastramento',
    },
  },
  {
    path: '/configuracoes/mensagens',
    component: () => import('@/modules/configuracoes/template-mensagens/views/pages/index.vue'),
    meta: {
      title: 'Mensagens',
      breadcrumbs: [
        breadcrumbsHome,
        breadcrumbsConfiguracoes,
        {
          name: 'Mensagens',
          pathName: null,
        },
      ],
      pagePermission: 'configuracoes/mensagens',
    },
  },
  {
    path: '/configuracoes/mensagens/nova',
    component: () => import('@/modules/configuracoes/template-mensagens/views/pages/CreateUpdateMessageTemplate.vue'),
    meta: {
      title: 'Criar template mensagem',
      breadcrumbs: [
        breadcrumbsHome,
        breadcrumbsConfiguracoes,
        {
          name: 'Mensagens',
          pathName: '/configuracoes/mensagens',
        },
        {
          name: 'Novo modelo de mensagem',
          pathName: null,
        },
      ],
      pagePermission: 'configuracoes/mensagens',
    },
  },
  {
    path: '/configuracoes/mensagens/:id',
    component: () => import('@/modules/configuracoes/template-mensagens/views/pages/CreateUpdateMessageTemplate.vue'),
    name: 'Editar template mensagem',
    meta: {
      title: 'Criar template mensagem',
      breadcrumbs: [
        breadcrumbsHome,
        breadcrumbsConfiguracoes,
        {
          name: 'Mensagens',
          pathName: '/configuracoes/mensagens',
        },
        {
          name: 'Novo modelo de mensagem',
          pathName: null,
        },
      ],
      pagePermission: 'configuracoes/mensagens',
    },
  },
  {
    path: '/configuracoes/permissionamento-filiado',
    component: () => import('@/modules/configuracoes/permissionamento-filiado/views/pages/Index.vue'),
    meta: {
      title: 'Permissionamento do filiado',
      breadcrumbs: [
        breadcrumbsHome,
        breadcrumbsConfiguracoes,
        {
          name: 'Permissionamento do filiado',
          pathName: null,
        },
      ],
      pagePermission: 'configuracoes/permissionamento-filiado',
    },
    children: [
      {
        path: 'gestao_consumidor',
        component: () => import('@/modules/configuracoes/permissionamento-filiado/views/components/GestaoConsumidor.vue'),
        meta: {
          title: 'Permissionamento do filiado',
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsConfiguracoes,
            {
              name: 'Permissionamento do filiado',
              pathName: null,
            },
          ],
          pagePermission: 'configuracoes/permissionamento-filiado',
        },
      },
      {
        path: 'aplicativo',
        component: () => import('@/modules/configuracoes/permissionamento-filiado/views/components/Aplicativo.vue'),
        meta: {
          title: 'Permissionamento do filiado',
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsConfiguracoes,
            {
              name: 'Permissionamento do filiado',
              pathName: null,
            },
          ],
          pagePermission: 'configuracoes/permissionamento-filiado',
        },
      },
      {
        path: 'trade',
        component: () => import('@/modules/configuracoes/permissionamento-filiado/views/components/Trade.vue'),
        meta: {
          title: 'Permissionamento do filiado',
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsConfiguracoes,
            {
              name: 'Permissionamento do filiado',
              pathName: null,
            },
          ],
          pagePermission: 'configuracoes/permissionamento-filiado',
        },
      },
    ],
  },
]
